'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { DownloadAppButton } from '@/components/DownloadAppButton';

type Props = {
  trackingId: string;
};

export function GetTheAppButton({ trackingId }: Props) {
  const t = useTranslations('seller');

  return (
    <DownloadAppButton
      className={styles.button}
      label={t('Sell.Cta.Label')}
      trackingId={trackingId}
    />
  );
}
